<form #crudForm="ngForm">
  <div>
    {{ 'profiles.edit.embedded-video.enter-html-code' | translate }}
  </div>
  <textarea class="form-control mb-15" [(ngModel)]="profileWidget.Html" name="embeddedVideo"></textarea>
  <button pButton type="button" class="atlas-btn atlas-btn-primary tall" type="button" (click)="clear()"
    title="{{ 'common.clear' | translate | titlecase }}">
    {{ 'common.clear' | translate | titlecase }}
  </button>
</form>